<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
    <RegisterEmailModal />
  </div>
</template>
<script>
import RegisterEmailModal from "@/components/RegisterEmailModal";

export default {
  name: "App",
  components: { RegisterEmailModal },
  mounted() {
    // eslint-disable-next-line
    $(document).on('shown.bs.modal', () => {
      this.$store.commit('setPopupOpen', true)
    })

    // eslint-disable-next-line
    $(document).on('hidden.bs.modal', () => {
      this.$store.commit('setPopupOpen', false)
    })
  }
};
</script>
<style>

:root {
--gold: #ffc107;
--dark: #333333;
--blue: #007bff;
--muted: #6c757d;
--glass: rgba(255,255,255,0.75);
}

input {
  width: 100%;
}

.tl-tag::before {
  content: "#";
  opacity: 0.8;
}

.tl-badge {
  color: #212529;
  background-color: #ffc107;
  margin-right: 2px;
}

.tl-inactive-badge {
  opacity: 70%;
  background-color: #ddd;
  cursor: default;
}

.tl-badge:hover {
  color: #212529;
}

.tl-link-title {
  font-size: 20px;
  font-weight: 400;
}

.tl-link {
  text-decoration: none;
  color: #007bff;
  position: relative;
  transition: color .3s ease-in-out;
  z-index: 1;
}

.tl-link-small {
  font-size: 13px;
  font-weight: 300;
  color: #222;
}

.tl-link:hover {
  text-decoration: none;
  color: darkblue;
}

.tl-link-block {
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 3px 3px 3px 0px rgba(100, 100, 100, 0.2);
  margin-bottom: 5px;
}

.tl-bookmark-block {
  background-color: white;
  padding-top: 10px;
  margin-top: 10px;
  border-radius: 5px;
  box-shadow: 3px 3px 3px 0px rgba(100, 100, 100, 0.2);
  margin-bottom: 5px;
}

.tl-link-block-header {
  border-bottom: 2px dotted lightgray
}

.tl-link-icon {
  font-size: 20px;
}

.tl-link-info-icon {
   color: #aaa;
}

.tl-link-open-icon {
   color: #007bff;
}

.tl-link-delete-icon {
  color: orangered;
}

.tl-link-copy-url-icon:hover {
  color: #aaa;
  text-decoration:none;
  cursor:pointer;
}

.tl-link-actions-icon {
  color:#666;
}

.tl-link-copy-url-icon-checked {
  color: forestgreen !important;
}

.icon-grow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
}

.icon-grow:hover, .icon-grow:focus, .icon-grow:active {
  -webkit-transform: scale(1.3);
  transform: scale(1.3);
}

.tl-link-delete-icon:hover {
  color: orangered;
  font-size: 20px;
  text-decoration:none;
  cursor:pointer;
}

.tl-icon-visibility {
  font-size: 16px;
}

.tl-icon-visibility-private {
  color: steelblue;
}

.tl-icon-visibility-public {
  color: #28a745;
}

body {
  font-family: system-ui, sans-serif;
  background-color: #f8f9fa;
  color: #212529;
}

.hero {
  padding: 4rem 1rem;
  background-color: #ffffff;
  text-align: center;
}

.hero h1 {
  font-size: 2.5rem;
  font-weight: bold;
}

.section {
  padding: 3rem 1rem;
}

.icon {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}

.manifesto {
  color: #6c757d;
}

.tl-emptystate-icon{
  color: lightgray;
  font-size: 50px;
}

.tl-user-header {
  color: #007bff
}

.tl-user-profile-icon {
  color: #aaa
}

.tl-breadcrumb-separator {
  color: #aaa;
}

.jumbotron#tl-jumbotron {
  padding-top: 2em;
}

.tl-subtext-header {
  font-size: 13px;
  font-weight: 300;
  color: #555;
}

.input-group.required label:before {
  content:"*";
  color:orangered;
  padding-right: 0.3em;
}

.card-choice { cursor: pointer; transition: transform .08s ease, box-shadow .08s ease; }
.card-choice:hover { transform: translateY(-4px); }
.card-choice .card-body { display:flex; align-items:center; justify-content:space-between; }

.fullscreen-image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.fullscreen-image {
  max-width: 90%;
  max-height: 90%;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 2rem;
  color: white;
  cursor: pointer;
}

.btn-cta {
  background: linear-gradient(90deg, var(--gold), #ffb000);
  border: none;
  color: rgba(0,0,0,0.85);
  box-shadow: 0 8px 24px rgba(255,193,7,0.12);
}

.btn-cta-large {
  padding: 0.9rem 1.35rem;
  border-radius: 12px;
}

.btn-cta-small {
  padding: 0.5rem 1rem;
  border-radius: 10px;
}

.btn-cta:hover, .btn-cta:focus {
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(255,193,7,0.16);
}
</style>
